import React, { useState } from "react";
import Input from "../../../components/Input/Input";
import { Fab, Tooltip, withStyles } from "@material-ui/core";
import DocumentTextIcon from "../../../components/Icon/DocumentTextIcon";
import TituloParcelas from "./TituloParcelas";
import { Button } from "../../../components/ui/Buttons";
import { gerarPagamentoAsaas } from "../../../services/FinanceiroService";

const TabPagamentoAsas = ({ classes, titulo, showAlertMessage, utilizaAsaas, agendamentoId, onLoadTitulos }) => {
  const [loadingGerarLink, setLoadingGerarLink] = useState(false);

  const copiarLink = () => {
    navigator.clipboard.writeText(titulo?.[0]?.linkPagamentoAsaas);
    showAlertMessage({
      isOpen: true,
      message: "Link copiado!",
      variant: "success",
    });
  };

  const onGerarLinkPagamento = async () => {
    setLoadingGerarLink(true);
    try {
      await gerarPagamentoAsaas({ agendamentoId });
      await onLoadTitulos();
      showAlertMessage({
        isOpen: true,
        message: "Link de pagamento gerado com sucesso!",
        variant: "success",
      });
    } catch (error) {
      showAlertMessage({
        isOpen: true,
        message: "Erro ao gerar link de pagamento.",
        variant: "error",
      });
    } finally {
      setLoadingGerarLink(false);
    }
  };

  return (
    <div className={classes.content}>
      {titulo?.[0]?.ativo && titulo?.[0]?.parcelas?.length > 0 ? (
        <>
          {titulo?.[0]?.linkPagamentoAsaas && (
            <div className={classes.wrapperInput}>
              <label className={classes.label}>Link de pagamento</label>
              <div className={classes.contentInput}>
                <Input
                  value={titulo?.[0]?.linkPagamentoAsaas}
                  hideStartAdornment
                  disabled
                  classes={{
                    root: classes.inputRoot,
                    input: classes.input,
                  }}
                />
                <Tooltip title="Copiar link" placement="top">
                  <Fab
                    size="small"
                    className={classes.fab}
                    onClick={copiarLink}
                  >
                    <DocumentTextIcon color="#FFF" />
                  </Fab>
                </Tooltip>
              </div>
            </div>
          )}
          <TituloParcelas tituloParcelas={titulo?.[0]?.parcelas} />
        </>
      ) : (
        utilizaAsaas ? (
          <div className={classes.gerarLinkContainer}>
            <Button
              bgColor="#219A97"
              onClick={onGerarLinkPagamento}
              disabled={loadingGerarLink}
            >
              Gerar link de pagamento
            </Button>
          </div>
        ) : (
          <div className={classes.mensagem}>Nenhum título encontrado!</div>
        )
      )}
    </div>
  );
};

const styles = {
  content: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    height: "100%",
  },
  wrapperInput: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "10px",
  },
  label: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#868686",
  },
  contentInput: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  inputRoot: {
    width: "100%",
    background: "#F2F2F2",
    border: "0.5px solid rgba(220, 220, 220, 0.2)",
    borderRadius: "8px",
    color: "#505050",
    fontSize: "14px",
  },
  input: {
    padding: "7px 0",
    fontFamily: "Poppins",
  },
  fab: {
    backgroundColor: "#219A97",
    color: "#FFF",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#009A97",
    },
    minWidth: "36px",
    width: "36px",
    height: "36px",
  },
  mensagem: {
    display: "flex",
    paddingTop: "20px",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    fontSize: "14px",
    fontWeight: "500",
    color: "#868686",
  },
  gerarLinkContainer: {
    display: "flex",
    paddingTop: "20px",
  },
};

export default withStyles(styles)(TabPagamentoAsas);
